import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function inventorySchemaDetailReducer(
  state = initialState.inventorySchemaDetail,
  action,
) {
  switch (action.type) {
    case actionTypes.GET_SCHEMA_DETAIL_SUCCESS: {
      return action.data;
    }
    default: {
      return state;
    }
  }
}
